if(!console.error) {
    console.error = console.log;
}